import React, { useState } from 'react';
import cls from './VolumeButton.module.scss';
import volumeOn from '../../../../../../assets/icons/volumeOn.svg';
import volumeOff from '../../../../../../assets/icons/volumeOff.svg';

interface VolumeButtonProps {
    onMute: () => void;
    muted: boolean;
    volume: number;
    onVolumeChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const VolumeButton = ({ onMute, muted, volume, onVolumeChange }: VolumeButtonProps) => {
    const [isSliderVisible, setIsSliderVisible] = useState(false);
    const showSlider = () => setIsSliderVisible(true);
    const hideSlider = () => setIsSliderVisible(false);

    return (
        <div className={cls.container}>
            <button
                className={cls.button}
                onClick={onMute}
                onMouseEnter={showSlider}
            >
                {muted
                    ? <img src={volumeOff} alt="No volume"/>
                    : <img src={volumeOn} alt="Volume"/>
                }
            </button>
            {isSliderVisible && (
                <div
                    className={cls.wrapper}
                    onMouseLeave={hideSlider}
                >
                    <input
                        className={cls.rangeInput}
                        type="range"
                        min="0"
                        max="100"
                        value={muted ? 0 : volume * 100}
                        onChange={onVolumeChange}
                    />
                </div>
            )}
        </div>
    );
}

export default VolumeButton;
